module.exports = __webpack_public_path__ + "img/IMG_2658.34af4c70.jpg";